module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "checkout-form__main checkout-form__same-day-order"
  }, [(_vm.hasError()) ? _c('div', {
    staticClass: "checkout-form__form-error js-checkout-errors"
  }, [_vm._v("\n      Please correct the following errors:\n      "), _c('ul', _vm._l((_vm.errors), function(message, field) {
    return _c('li', [_c('a', {
      attrs: {
        "href": _vm.fieldErrorLink(field)
      }
    }, [_vm._v(_vm._s(message))])])
  }))]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "checkout-form__form"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.collectionMethod === null),
      expression: "collectionMethod === null"
    }],
    staticClass: "checkout-form__collection-method"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "checkout-form__collection-method-choices"
  }, [_c('div', {
    staticClass: "checkout-form__collection-method-choice checkout-form__collection-method-choice--pickup"
  }, [_c('button', {
    staticClass: "checkout-form__collection-method-choice-button",
    class: {
      'checkout-form__collection-method-choice-button--active': !_vm.flyboyPickupIsDelivery
    },
    attrs: {
      "type": "button",
      "disabled": !_vm.collectionMethodAvailable('pickup'),
      "title": _vm.collectionMethodAvailable('pickup') ? '' : 'We are currently unable to take same day orders for pickup'
    },
    on: {
      "click": function($event) {
        _vm.setCollectionMethod('pickup')
      }
    }
  }, [_vm._v("Pickup")])]), _vm._v(" "), _c('div', {
    staticClass: "checkout-form__collection-method-choice checkout-form__collection-method-choice--delivery"
  }, [_c('button', {
    staticClass: "checkout-form__collection-method-choice-button",
    class: {
      'checkout-form__collection-method-choice-button--active': _vm.flyboyPickupIsDelivery
    },
    attrs: {
      "type": "button",
      "disabled": !_vm.collectionMethodAvailable('delivery'),
      "title": _vm.collectionMethodAvailable('delivery') ? '' : 'We are currently unable to take same day orders for delivery'
    },
    on: {
      "click": function($event) {
        _vm.setCollectionMethod('delivery')
      }
    }
  }, [_vm._v("Delivery")]), _vm._v(" "), _c('div', {
    staticClass: "checkout-form__collection-method-choice-note"
  }, [_vm._v("$15 minimum order")])])])]), _vm._v(" "), _c('form', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.collectionMethod !== null),
      expression: "collectionMethod !== null"
    }],
    attrs: {
      "novalidate": "",
      "method": "post",
      "action": _vm.checkoutAction
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.handleFormSubmit($event)
      }
    }
  }, [_c('fieldset', {
    staticClass: "checkout-form__fieldset"
  }, [_c('legend', {
    staticClass: "checkout-form__legend"
  }, [_vm._v("\n            " + _vm._s(_vm.flyboyPickupIsDelivery ? 'Delivery Info' : 'Pickup Info') + "\n            "), (_vm.numCollectionMethodsAvailable > 1) ? _c('div', {
    staticClass: "checkout-form__collection-method-toggle"
  }, [_c('a', {
    attrs: {
      "href": "#switch"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.toggleCollectionMethod($event)
      }
    }
  }, [_vm._v("Switch to " + _vm._s(_vm.flyboyPickupIsDelivery ? 'pickup' : 'delivery'))])]) : _vm._e(), _vm._v(" "), _c('img', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isLocationInfoUpdating),
      expression: "isLocationInfoUpdating"
    }],
    attrs: {
      "src": _vm.loadingIndicatorSrc,
      "width": "16",
      "height": "16",
      "alt": ""
    }
  })]), _vm._v(" "), (_vm.flyboyPickupIsDelivery) ? _c('div', {
    staticClass: "checkout-form__input",
    class: {
      'checkout-form__input--has-error': _vm.hasError('flyboy_location_id')
    },
    attrs: {
      "id": "flyboy_location_id"
    }
  }, [_c('div', {
    staticClass: "checkout-form__input-field-locations"
  }, _vm._l((_vm.flyboyLocationOptionsOriginalDelivery), function(location) {
    return _c('label', [_c('img', {
      attrs: {
        "src": location.photo_src,
        "alt": ""
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "checkout-form__input-field-locations-title-info"
    }, [_c('div', {
      staticClass: "checkout-form__input-field-locations-title"
    }, [_vm._v("\n                    " + _vm._s(location.title) + "\n                  ")]), _vm._v(" "), (location.additional_info_same_day) ? _c('div', {
      staticClass: "checkout-form__input-field-locations-info",
      domProps: {
        "innerHTML": _vm._s(location.additional_info_same_day)
      }
    }) : _vm._e()])])
  }))]) : _c('div', [_c('div', {
    staticClass: "checkout-form__input-error"
  }, [_vm._v("\n              " + _vm._s(_vm.getError('flyboy_location_id')) + "\n            ")]), _vm._v(" "), _c('div', {
    staticClass: "checkout-form__input-field-locations"
  }, _vm._l((_vm.flyboyLocationOptionsNotOriginalDelivery), function(location) {
    return _c('label', {
      class: {
        'this-location-not-available': !_vm.locationAvailableToday(location)
      }
    }, [_c('img', {
      attrs: {
        "src": location.photo_src,
        "alt": ""
      }
    }), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.flyboyPickupInfo.locationId),
        expression: "flyboyPickupInfo.locationId"
      }],
      attrs: {
        "type": "radio",
        "name": "flyboy_location_id",
        "disabled": !_vm.locationAvailableToday(location)
      },
      domProps: {
        "value": location.id,
        "checked": _vm._q(_vm.flyboyPickupInfo.locationId, location.id)
      },
      on: {
        "__c": function($event) {
          _vm.flyboyPickupInfo.locationId = location.id
        }
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "checkout-form__input-field-locations-title-info"
    }, [_c('div', {
      staticClass: "checkout-form__input-field-locations-title"
    }, [_vm._v("\n                    " + _vm._s(location.title) + "\n                  ")]), _vm._v(" "), (location.additional_info_same_day) ? _c('div', {
      staticClass: "checkout-form__input-field-locations-info",
      domProps: {
        "innerHTML": _vm._s(location.additional_info_same_day)
      }
    }) : _vm._e()])])
  }))]), _vm._v(" "), _c('div', {
    staticClass: "checkout-form__input",
    class: {
      'checkout-form__input--has-error': _vm.hasError('flyboy_pickup_at')
    }
  }, [_c('div', {
    staticClass: "checkout-form__input-error"
  }, [_vm._v("\n              " + _vm._s(_vm.getError('flyboy_pickup_at')) + "\n            ")]), _vm._v(" "), _c('div', {
    staticClass: "checkout-form__input-label"
  }, [_c('label', {
    attrs: {
      "for": "flyboyPickupTime"
    }
  }, [_vm._v(_vm._s(_vm.flyboyPickupIsDelivery ? 'Deliver between' : 'Have ready by') + " *")])]), _vm._v(" "), _c('div', {
    staticClass: "checkout-form__input-field"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!(_vm.flyboyPickupInfo.locationId && _vm.flyboyPickupInfo.date)),
      expression: "!(flyboyPickupInfo.locationId && flyboyPickupInfo.date)"
    }],
    staticClass: "checkout-form__input-note"
  }, [_vm._v("\n                NOTE: choose a location to see available times.\n              ")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.flyboyPickupInfo.time),
      expression: "flyboyPickupInfo.time"
    }],
    attrs: {
      "id": "flyboyPickupTime",
      "name": "flyboyPickupTime"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.flyboyPickupInfo.time = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    domProps: {
      "value": null
    }
  }, [_vm._v("--Choose--")]), _vm._v(" "), _vm._l((_vm.flyboyPickupTimeOptions), function(value, key) {
    return _c('option', {
      domProps: {
        "value": key
      }
    }, [_vm._v(_vm._s(value + " on " + _vm.monthAndDay))])
  })], 2)])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.flyboyPickupIsDelivery),
      expression: "flyboyPickupIsDelivery"
    }]
  }, [_c('div', {
    staticClass: "checkout-form__input-group"
  }, [_c('div', {
    staticClass: "checkout-form__input",
    class: {
      'checkout-form__input--has-error': _vm.hasError('flyboy_deliver_contact')
    }
  }, [_c('div', {
    staticClass: "checkout-form__input-error"
  }, [_vm._v("\n                  " + _vm._s(_vm.getError('flyboy_deliver_contact')) + "\n                ")]), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "checkout-form__input-field"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.trim",
      value: (_vm.flyboyPickupInfo.deliverContact),
      expression: "flyboyPickupInfo.deliverContact",
      modifiers: {
        "trim": true
      }
    }],
    attrs: {
      "type": "text",
      "name": "flyboy_deliver_contact",
      "id": "flyboy_deliver_contact",
      "maxlength": "255"
    },
    domProps: {
      "value": (_vm.flyboyPickupInfo.deliverContact)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.flyboyPickupInfo.deliverContact = $event.target.value.trim()
      },
      "blur": function($event) {
        _vm.$forceUpdate()
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "checkout-form__input",
    class: {
      'checkout-form__input--has-error': _vm.hasError('flyboy_deliver_phone')
    }
  }, [_c('div', {
    staticClass: "checkout-form__input-error"
  }, [_vm._v("\n                  " + _vm._s(_vm.getError('flyboy_deliver_phone')) + "\n                ")]), _vm._v(" "), _vm._m(2), _vm._v(" "), _c('div', {
    staticClass: "checkout-form__input-field"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.trim",
      value: (_vm.flyboyPickupInfo.deliverPhone),
      expression: "flyboyPickupInfo.deliverPhone",
      modifiers: {
        "trim": true
      }
    }],
    attrs: {
      "type": "tel",
      "name": "flyboy_deliver_phone",
      "id": "flyboy_deliver_phone",
      "maxlength": "25"
    },
    domProps: {
      "value": (_vm.flyboyPickupInfo.deliverPhone)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.flyboyPickupInfo.deliverPhone = $event.target.value.trim()
      }, function($event) {
        _vm.dashify('flyboyPickupInfo', 'deliverPhone')
      }],
      "blur": function($event) {
        _vm.$forceUpdate()
      }
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "checkout-form__input-note",
    staticStyle: {
      "margin": "-12px 0 13px"
    }
  }, [_vm._v("\n              If at business please list name of person AND name of business\n            ")]), _vm._v(" "), _c('div', {
    staticClass: "checkout-form__input-group"
  }, [_c('div', {
    staticClass: "checkout-form__input",
    class: {
      'checkout-form__input--has-error': _vm.hasError('flyboy_deliver_to')
    }
  }, [_c('div', {
    staticClass: "checkout-form__input-error"
  }, [_vm._v("\n                  " + _vm._s(_vm.getError('flyboy_deliver_to')) + "\n                ")]), _vm._v(" "), _vm._m(3), _vm._v(" "), _c('div', {
    staticClass: "checkout-form__input-field"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.flyboyPickupInfo.deliverTo),
      expression: "flyboyPickupInfo.deliverTo"
    }],
    ref: "flyboy_deliver_to",
    attrs: {
      "type": "text",
      "name": "flyboy_deliver_to",
      "id": "flyboy_deliver_to"
    },
    domProps: {
      "value": (_vm.flyboyPickupInfo.deliverTo)
    },
    on: {
      "keyup": _vm.addressManuallyChanged,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.flyboyPickupInfo.deliverTo = $event.target.value
      }
    }
  }), _vm._v(" "), _c('div', [(_vm.calculatingDeliveryFee || _vm.cartSummary.delivery_amt > 0) ? [_vm._v("\n                      Delivery fee:\n                        "), (_vm.calculatingDeliveryFee) ? _c('img', {
    attrs: {
      "src": _vm.loadingIndicatorSrc,
      "width": "16",
      "height": "16",
      "alt": ""
    }
  }) : [_vm._v(_vm._s(_vm.priceFormat(_vm.cartSummary.delivery_amt)))]] : _vm._e()], 2)])])]), _vm._v(" "), _c('div', {
    staticClass: "checkout-form__input-group"
  }, [_c('div', {
    staticClass: "checkout-form__input",
    class: {
      'checkout-form__input--has-error': _vm.hasError('flyboy_deliver_message')
    }
  }, [_c('div', {
    staticClass: "checkout-form__input-error"
  }, [_vm._v("\n                  " + _vm._s(_vm.getError('flyboy_deliver_message')) + "\n                ")]), _vm._v(" "), _vm._m(4), _vm._v(" "), _c('div', {
    staticClass: "checkout-form__input-field"
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.flyboyPickupInfo.deliverMessage),
      expression: "flyboyPickupInfo.deliverMessage"
    }],
    attrs: {
      "name": "flyboy_deliver_message",
      "id": "flyboy_deliver_message"
    },
    domProps: {
      "value": (_vm.flyboyPickupInfo.deliverMessage)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.flyboyPickupInfo.deliverMessage = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "checkout-form__input",
    class: {
      'checkout-form__input--has-error': _vm.hasError('flyboy_deliver_instructions')
    }
  }, [_c('div', {
    staticClass: "checkout-form__input-error"
  }, [_vm._v("\n                  " + _vm._s(_vm.getError('flyboy_deliver_instructions')) + "\n                ")]), _vm._v(" "), _vm._m(5), _vm._v(" "), _c('div', {
    staticClass: "checkout-form__input-field"
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.flyboyPickupInfo.deliverInstructions),
      expression: "flyboyPickupInfo.deliverInstructions"
    }],
    attrs: {
      "name": "flyboy_deliver_instructions",
      "id": "flyboy_deliver_instructions"
    },
    domProps: {
      "value": (_vm.flyboyPickupInfo.deliverInstructions)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.flyboyPickupInfo.deliverInstructions = $event.target.value
      }
    }
  })])])])])]), _vm._v(" "), _c('fieldset', {
    staticClass: "checkout-form__fieldset"
  }, [_c('legend', {
    staticClass: "checkout-form__legend"
  }, [_vm._v("Choose the quantity of any items you would like...")]), _vm._v(" "), _c('div', {
    staticClass: "shopping-cart-same-day"
  }, [_c('div', {
    staticClass: "shopping-cart-same-day__items"
  }, _vm._l((_vm.products), function(product) {
    return _c('div', {
      staticClass: "shopping-cart-same-day__item"
    }, [_c('div', {
      staticClass: "shopping-cart-same-day__item-image"
    }, [_c('img', {
      attrs: {
        "src": product.primary_photo_src,
        "alt": product.primary_photo_alt
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "shopping-cart-same-day__item-title"
    }, [_c('h3', [_vm._v(_vm._s(product.title))])]), _vm._v(" "), (product.options) ? _c('div', {
      staticClass: "shopping-cart-same-day__item-options"
    }) : _vm._e(), _vm._v(" "), _c('div', {
      staticClass: "shopping-cart-same-day__item-price"
    }, [_c('span', {
      domProps: {
        "innerHTML": _vm._s(product.price_html)
      }
    }), _vm._v(" ea.")]), _vm._v(" "), _c('div', {
      staticClass: "shopping-cart-same-day__item-quantity"
    }, [_c('button', {
      attrs: {
        "type": "button"
      },
      on: {
        "click": function($event) {
          _vm.quantityDecrement(product.id)
        }
      }
    }, [_vm._v("-")]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.productQuantities[product.id]),
        expression: "productQuantities[product.id]"
      }],
      attrs: {
        "type": "number",
        "min": "0"
      },
      domProps: {
        "value": (_vm.productQuantities[product.id])
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(_vm.productQuantities, product.id, $event.target.value)
        }
      }
    }), _vm._v(" "), _c('button', {
      attrs: {
        "type": "button"
      },
      on: {
        "click": function($event) {
          _vm.quantityIncrement(product.id)
        }
      }
    }, [_vm._v("+")])])])
  }))])]), _vm._v(" "), _c('fieldset', {
    staticClass: "checkout-form__fieldset"
  }, [_c('legend', {
    staticClass: "checkout-form__legend"
  }, [_vm._v("Coupon/Promo Code")]), _vm._v(" "), _c('div', {
    staticClass: "checkout-form__input",
    class: {
      'checkout-form__input--has-error': _vm.hasError('coupon_code')
    }
  }, [_c('div', {
    staticClass: "checkout-form__input-field"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.trim",
      value: (_vm.flyboyPickupInfo.couponCode),
      expression: "flyboyPickupInfo.couponCode",
      modifiers: {
        "trim": true
      }
    }],
    attrs: {
      "type": "text",
      "name": "coupon_code",
      "id": "coupon_code",
      "maxlength": "255"
    },
    domProps: {
      "value": (_vm.flyboyPickupInfo.couponCode)
    },
    on: {
      "keypress": _vm.couponCodeKeypress,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.flyboyPickupInfo.couponCode = $event.target.value.trim()
      },
      "blur": function($event) {
        _vm.$forceUpdate()
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "checkout-form__coupon-submit"
  }, [_c('button', {
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.applyCoupon($event)
      }
    }
  }, [_vm._v("Apply")])]), _vm._v(" "), _c('div', {
    staticClass: "checkout-form__input-error"
  }, [_vm._v("\n                " + _vm._s(_vm.getError('coupon_code')) + "\n              ")])])]), _vm._v(" "), _c('fieldset', {
    staticClass: "checkout-form__fieldset"
  }, [_c('legend', {
    staticClass: "checkout-form__legend"
  }, [_vm._v("Tip")]), _vm._v(" "), _c('div', {
    staticClass: "checkout-form__input-field-tips"
  }, [_c('div', {
    staticClass: "checkout-form__input-field-tips-input"
  }, [_c('div', {
    staticClass: "checkout-form__input-field-tips-input-percents"
  }, [_c('button', {
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.setTipToPercent(10)
      }
    }
  }, [_vm._v("10%")]), _vm._v(" "), _c('button', {
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.setTipToPercent(15)
      }
    }
  }, [_vm._v("15%")]), _vm._v(" "), _c('button', {
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.setTipToPercent(20)
      }
    }
  }, [_vm._v("20%")])]), _vm._v(" "), _c('div', {
    staticClass: "checkout-form__input-field-tips-input-label-and-input"
  }, [_vm._m(6), _vm._v(" "), _c('div', {
    staticClass: "checkout-form__input-field-tips-input-field"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.number",
      value: (_vm.tipAmountDisplay),
      expression: "tipAmountDisplay",
      modifiers: {
        "number": true
      }
    }],
    staticClass: "currency",
    attrs: {
      "type": "number",
      "min": "0",
      "max": "100",
      "name": "tipAmount",
      "id": "tipAmount"
    },
    domProps: {
      "value": (_vm.tipAmountDisplay)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.tipAmountDisplay = _vm._n($event.target.value)
      },
      "blur": function($event) {
        _vm.$forceUpdate()
      }
    }
  })])])]), _vm._v(" "), _vm._m(7)])]), _vm._v(" "), _c('fieldset', {
    staticClass: "checkout-form__fieldset"
  }, [_c('legend', {
    staticClass: "checkout-form__legend"
  }, [_vm._v("Cart Summary "), _c('img', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isLocationInfoUpdating),
      expression: "isLocationInfoUpdating"
    }],
    attrs: {
      "src": _vm.loadingIndicatorSrc,
      "width": "16",
      "height": "16",
      "alt": ""
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "checkout-form__summary"
  }, [_c('div', {
    staticClass: "checkout-form__summary-liner"
  }, [_c('div', {
    staticClass: "checkout-form__summary-price"
  }, [_c('div', {
    staticClass: "checkout-form__summary-price-title"
  }, [_vm._v("\n                  Subtotal\n                ")]), _vm._v(" "), _c('div', {
    staticClass: "checkout-form__summary-price-value"
  }, [_vm._v("\n                  " + _vm._s(_vm.priceFormat(_vm.subtotal)) + "\n                ")])]), _vm._v(" "), (_vm.flyboyPickupIsDelivery) ? _c('div', {
    staticClass: "checkout-form__summary-price"
  }, [_c('div', {
    staticClass: "checkout-form__summary-price-title"
  }, [_vm._v("\n                 Delivery Fee\n                ")]), _vm._v(" "), _c('div', {
    staticClass: "checkout-form__summary-price-value"
  }, [_vm._v("\n                  " + _vm._s(_vm.priceFormat(_vm.cartSummary.delivery_amt)) + "\n                ")])]) : _vm._e(), _vm._v(" "), (_vm.cartSummary.surcharge_amt) ? _c('div', {
    staticClass: "checkout-form__summary-price"
  }, [_c('div', {
    staticClass: "checkout-form__summary-price-title"
  }, [_vm._v("\n                  " + _vm._s(_vm.cartSummary.surcharge_desc) + "\n                ")]), _vm._v(" "), _c('div', {
    staticClass: "checkout-form__summary-price-value"
  }, [_vm._v("\n                  " + _vm._s(_vm.priceFormat(_vm.cartSummary.surcharge_amt)) + "\n                ")])]) : _vm._e(), _vm._v(" "), (_vm.surcharge_pct_amt > 0) ? _c('div', {
    staticClass: "checkout-form__summary-price"
  }, [_c('div', {
    staticClass: "checkout-form__summary-price-title"
  }, [_vm._v("\n                  " + _vm._s(_vm.cartSummary.surcharge_pct_desc) + "\n                ")]), _vm._v(" "), _c('div', {
    staticClass: "checkout-form__summary-price-value"
  }, [_vm._v("\n                  " + _vm._s(_vm.priceFormat(_vm.surcharge_pct_amt)) + "\n                ")])]) : _vm._e(), _vm._v(" "), (_vm.haveCoupon) ? _c('div', {
    staticClass: "checkout-form__summary-price"
  }, [_c('div', {
    staticClass: "checkout-form__summary-price-title"
  }, [_vm._v("\n                  Discount " + _vm._s(_vm.discount_message ? '(' + _vm.discount_message + ')' : '') + "\n                ")]), _vm._v(" "), _c('div', {
    staticClass: "checkout-form__summary-price-value"
  }, [_vm._v("\n                  " + _vm._s(_vm.priceFormat(_vm.discount_amt, '', '-$')) + "\n                ")])]) : _vm._e(), _vm._v(" "), (_vm.tax_amt) ? _c('div', {
    staticClass: "checkout-form__summary-price"
  }, [_c('div', {
    staticClass: "checkout-form__summary-price-title"
  }, [_vm._v("\n                  Sales Tax (" + _vm._s(_vm.cartSummary.tax_pct) + "%)\n                ")]), _vm._v(" "), _c('div', {
    staticClass: "checkout-form__summary-price-value"
  }, [_vm._v("\n                  " + _vm._s(_vm.priceFormat(_vm.tax_amt)) + "\n                ")])]) : _vm._e(), _vm._v(" "), (_vm.tipAmount) ? _c('div', {
    staticClass: "checkout-form__summary-price"
  }, [_c('div', {
    staticClass: "checkout-form__summary-price-title"
  }, [_vm._v("\n                  Tip\n                ")]), _vm._v(" "), _c('div', {
    staticClass: "checkout-form__summary-price-value"
  }, [_vm._v("\n                  " + _vm._s(_vm.priceFormat(_vm.tipAmount)) + "\n                ")])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "checkout-form__summary-price checkout-form__summary-price--add-spacer checkout-form__summary-price--large"
  }, [_c('div', {
    staticClass: "checkout-form__summary-price-title"
  }, [_vm._v("\n                  Grand Total\n                ")]), _vm._v(" "), _c('div', {
    staticClass: "checkout-form__summary-price-value"
  }, [_vm._v("\n                  " + _vm._s(_vm.priceFormat(_vm.grand_total_incl_tip)) + "\n                ")])])])])]), _vm._v(" "), _c('fieldset', {
    staticClass: "checkout-form__fieldset"
  }, [_c('legend', {
    staticClass: "checkout-form__legend"
  }, [_vm._v("Comments")]), _vm._v(" "), _c('div', {
    staticClass: "checkout-form__input",
    class: {
      'checkout-form__input--has-error': _vm.hasError('customer_comments')
    }
  }, [_c('div', {
    staticClass: "checkout-form__input-error"
  }, [_vm._v("\n              " + _vm._s(_vm.getError('customer_comments')) + "\n            ")]), _vm._v(" "), _vm._m(8), _vm._v(" "), _c('div', {
    staticClass: "checkout-form__input-note"
  }, [_vm._v("\n              * Please note that if you want specific donuts included in your dozens you may comment here, but we can NOT guarantee these will be available depending on supply.\n            ")]), _vm._v(" "), _c('div', {
    staticClass: "checkout-form__input-field"
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.flyboyPickupInfo.customer_comments),
      expression: "flyboyPickupInfo.customer_comments"
    }],
    attrs: {
      "name": "customer_comments",
      "id": "customer_comments"
    },
    domProps: {
      "value": (_vm.flyboyPickupInfo.customer_comments)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.flyboyPickupInfo.customer_comments = $event.target.value
      }
    }
  })])])]), _vm._v(" "), _c('fieldset', {
    staticClass: "checkout-form__fieldset"
  }, [_c('legend', {
    staticClass: "checkout-form__legend"
  }, [_vm._v("Your Contact Info")]), _vm._v(" "), _c('div', {
    staticClass: "checkout-form__input-group"
  }, [_c('div', {
    staticClass: "checkout-form__input",
    class: {
      'checkout-form__input--has-error': _vm.hasError('customer_first_name')
    }
  }, [_c('div', {
    staticClass: "checkout-form__input-error"
  }, [_vm._v("\n                " + _vm._s(_vm.getError('customer_first_name')) + "\n              ")]), _vm._v(" "), _vm._m(9), _vm._v(" "), _c('div', {
    staticClass: "checkout-form__input-field"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.trim",
      value: (_vm.customerInfo.customer_first_name),
      expression: "customerInfo.customer_first_name",
      modifiers: {
        "trim": true
      }
    }],
    attrs: {
      "type": "text",
      "name": "customer_first_name",
      "id": "customer_first_name",
      "maxlength": "255"
    },
    domProps: {
      "value": (_vm.customerInfo.customer_first_name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.customerInfo.customer_first_name = $event.target.value.trim()
      },
      "blur": function($event) {
        _vm.$forceUpdate()
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "checkout-form__input",
    class: {
      'checkout-form__input--has-error': _vm.hasError('customer_last_name')
    }
  }, [_c('div', {
    staticClass: "checkout-form__input-error"
  }, [_vm._v("\n                " + _vm._s(_vm.getError('customer_last_name')) + "\n              ")]), _vm._v(" "), _vm._m(10), _vm._v(" "), _c('div', {
    staticClass: "checkout-form__input-field"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.trim",
      value: (_vm.customerInfo.customer_last_name),
      expression: "customerInfo.customer_last_name",
      modifiers: {
        "trim": true
      }
    }],
    attrs: {
      "type": "text",
      "name": "customer_last_name",
      "id": "customer_last_name",
      "maxlength": "255"
    },
    domProps: {
      "value": (_vm.customerInfo.customer_last_name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.customerInfo.customer_last_name = $event.target.value.trim()
      },
      "blur": function($event) {
        _vm.$forceUpdate()
      }
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "checkout-form__input-group"
  }, [_c('div', {
    staticClass: "checkout-form__input",
    class: {
      'checkout-form__input--has-error': _vm.hasError('customer_email')
    }
  }, [_c('div', {
    staticClass: "checkout-form__input-error"
  }, [_vm._v("\n                " + _vm._s(_vm.getError('customer_email')) + "\n              ")]), _vm._v(" "), _vm._m(11), _vm._v(" "), _c('div', {
    staticClass: "checkout-form__input-field"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.trim",
      value: (_vm.customerInfo.customer_email),
      expression: "customerInfo.customer_email",
      modifiers: {
        "trim": true
      }
    }],
    attrs: {
      "type": "email",
      "name": "customer_email",
      "id": "customer_email",
      "maxlength": "255"
    },
    domProps: {
      "value": (_vm.customerInfo.customer_email)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.customerInfo.customer_email = $event.target.value.trim()
      },
      "blur": function($event) {
        _vm.$forceUpdate()
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "checkout-form__input",
    class: {
      'checkout-form__input--has-error': _vm.hasError('customer_phone')
    }
  }, [_c('div', {
    staticClass: "checkout-form__input-error"
  }, [_vm._v("\n                " + _vm._s(_vm.getError('customer_phone')) + "\n              ")]), _vm._v(" "), _vm._m(12), _vm._v(" "), _c('div', {
    staticClass: "checkout-form__input-field"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.trim",
      value: (_vm.customerInfo.customer_phone),
      expression: "customerInfo.customer_phone",
      modifiers: {
        "trim": true
      }
    }],
    attrs: {
      "type": "tel",
      "name": "customer_phone",
      "id": "customer_phone",
      "maxlength": "25"
    },
    domProps: {
      "value": (_vm.customerInfo.customer_phone)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.customerInfo.customer_phone = $event.target.value.trim()
      }, function($event) {
        _vm.dashify('customerInfo', 'customer_phone')
      }],
      "blur": function($event) {
        _vm.$forceUpdate()
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "checkout-form__input",
    class: {
      'checkout-form__input--has-error': _vm.hasError('customer_zip')
    }
  }, [_c('div', {
    staticClass: "checkout-form__input-error"
  }, [_vm._v("\n                " + _vm._s(_vm.getError('customer_zip')) + "\n              ")]), _vm._v(" "), _vm._m(13), _vm._v(" "), _c('div', {
    staticClass: "checkout-form__input-field"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.trim",
      value: (_vm.customerInfo.customer_zip),
      expression: "customerInfo.customer_zip",
      modifiers: {
        "trim": true
      }
    }],
    attrs: {
      "type": "text",
      "name": "customer_zip",
      "id": "customer_zip",
      "maxlength": "25"
    },
    domProps: {
      "value": (_vm.customerInfo.customer_zip)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.customerInfo.customer_zip = $event.target.value.trim()
      },
      "blur": function($event) {
        _vm.$forceUpdate()
      }
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "checkout-form__input-group"
  }, [_c('div', {
    staticClass: "checkout-form__input"
  }, [_c('span', {
    staticClass: "checkout-form__input-field"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.mailOptin),
      expression: "mailOptin"
    }],
    attrs: {
      "type": "checkbox",
      "name": "mailOptin",
      "id": "mailOptin",
      "value": "1"
    },
    domProps: {
      "checked": Array.isArray(_vm.mailOptin) ? _vm._i(_vm.mailOptin, "1") > -1 : (_vm.mailOptin)
    },
    on: {
      "__c": function($event) {
        var $$a = _vm.mailOptin,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = "1",
            $$i = _vm._i($$a, $$v);
          if ($$c) {
            $$i < 0 && (_vm.mailOptin = $$a.concat($$v))
          } else {
            $$i > -1 && (_vm.mailOptin = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.mailOptin = $$c
        }
      }
    }
  })]), _vm._v("\n               "), _vm._m(14)])])]), _vm._v(" "), _c('fieldset', {
    staticClass: "checkout-form__fieldset",
    attrs: {
      "id": "payment-fieldset"
    }
  }, [_c('legend', {
    staticClass: "checkout-form__legend"
  }, [_vm._v("Payment Information "), _c('img', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isLocationInfoUpdating),
      expression: "isLocationInfoUpdating"
    }],
    attrs: {
      "src": _vm.loadingIndicatorSrc,
      "width": "16",
      "height": "16",
      "alt": ""
    }
  })]), _vm._v(" "), _c('div', {
    class: {
      'checkout-form__input-group-error': _vm.hasError('stripe')
    }
  }, [_vm._v("\n            " + _vm._s(_vm.getError('stripe')) + "\n          ")]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.productQuantitiesTotal < 1),
      expression: "productQuantitiesTotal < 1"
    }],
    staticClass: "checkout-form__input"
  }, [_vm._v("\n            Please select the items you'd like to order above.\n          ")]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.grand_total > 0 && _vm.isOfflinePaymentAllowed),
      expression: "grand_total > 0 && isOfflinePaymentAllowed"
    }],
    staticClass: "checkout-form__input"
  }, [_c('div', {
    staticClass: "checkout-form__input-field"
  }, [_c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.isOfflinePayment),
      expression: "isOfflinePayment"
    }],
    attrs: {
      "type": "radio",
      "name": "is_offline_payment"
    },
    domProps: {
      "value": false,
      "checked": _vm._q(_vm.isOfflinePayment, false)
    },
    on: {
      "__c": function($event) {
        _vm.isOfflinePayment = false
      }
    }
  }), _vm._v("\n                Pay online (now)\n              ")]), _vm._v(" "), _c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.isOfflinePayment),
      expression: "isOfflinePayment"
    }],
    attrs: {
      "type": "radio",
      "name": "is_offline_payment"
    },
    domProps: {
      "value": true,
      "checked": _vm._q(_vm.isOfflinePayment, true)
    },
    on: {
      "__c": function($event) {
        _vm.isOfflinePayment = true
      }
    }
  }), _vm._v("\n                Pay in store (when I pick up the order)\n              ")])])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.grand_total > 0 && !(_vm.isOfflinePaymentAllowed && _vm.isOfflinePayment)),
      expression: "grand_total > 0 && !(isOfflinePaymentAllowed && isOfflinePayment)"
    }]
  }, [_vm._m(15)])]), _vm._v(" "), (!_vm.customerInfo.is_logged_in) ? _c('fieldset', {
    staticClass: "checkout-form__fieldset"
  }, [_c('legend', {
    staticClass: "checkout-form__legend"
  }, [_vm._v("Registration (Optional)")]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.accountExists),
      expression: "!accountExists"
    }],
    staticClass: "checkout-form__fieldset-note"
  }, [_vm._v("\n            Registering allows you to log in to the website and review your order history. It also makes the checkout process quicker in the future since your contact info can be automatically filled in.\n          ")]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.accountExists && !_vm.accountShowRegistrationFields),
      expression: "!accountExists && !accountShowRegistrationFields"
    }],
    staticClass: "checkout-form__input"
  }, [_c('div', {
    staticClass: "checkout-form__input-field"
  }, [_c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.customerInfo.register),
      expression: "customerInfo.register"
    }],
    attrs: {
      "type": "checkbox",
      "name": "register"
    },
    domProps: {
      "checked": Array.isArray(_vm.customerInfo.register) ? _vm._i(_vm.customerInfo.register, null) > -1 : (_vm.customerInfo.register)
    },
    on: {
      "__c": function($event) {
        var $$a = _vm.customerInfo.register,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$c) {
            $$i < 0 && (_vm.customerInfo.register = $$a.concat($$v))
          } else {
            $$i > -1 && (_vm.customerInfo.register = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.customerInfo.register = $$c
        }
      }
    }
  }), _vm._v("\n                Register a new account\n              ")])])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.accountCheckingEmail),
      expression: "accountCheckingEmail"
    }]
  }, [_vm._v("\n            Checking email address...\n          ")]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.accountCheckingEmail && _vm.accountExists),
      expression: "!accountCheckingEmail && accountExists"
    }]
  }, [_vm._v("\n            We found an account with your email address in our records. We will associate this order with your account.\n          ")]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.accountCheckingEmail && _vm.accountShowRegistrationFields),
      expression: "!accountCheckingEmail && accountShowRegistrationFields"
    }]
  }, [_c('div', {
    staticClass: "checkout-form__input",
    class: {
      'checkout-form__input--has-error': _vm.hasError('password')
    }
  }, [_c('div', {
    staticClass: "checkout-form__input-error"
  }, [_vm._v("\n                " + _vm._s(_vm.getError('password')) + "\n              ")]), _vm._v(" "), _vm._m(16), _vm._v(" "), _c('div', {
    staticClass: "checkout-form__input-field"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.customerInfo.password),
      expression: "customerInfo.password"
    }],
    attrs: {
      "type": "password",
      "name": "password",
      "id": "password"
    },
    domProps: {
      "value": (_vm.customerInfo.password)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.customerInfo.password = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "checkout-form__input",
    class: {
      'checkout-form__input--has-error': _vm.hasError('password_confirm')
    }
  }, [_c('div', {
    staticClass: "checkout-form__input-error"
  }, [_vm._v("\n                " + _vm._s(_vm.getError('password_confirm')) + "\n              ")]), _vm._v(" "), _vm._m(17), _vm._v(" "), _c('div', {
    staticClass: "checkout-form__input-field"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.customerInfo.password_confirm),
      expression: "customerInfo.password_confirm"
    }],
    attrs: {
      "type": "password",
      "name": "password_confirm",
      "id": "password_confirm"
    },
    domProps: {
      "value": (_vm.customerInfo.password_confirm)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.customerInfo.password_confirm = $event.target.value
      }
    }
  })])])])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "checkout-form__submit"
  }, [_c('div', {
    staticClass: "checkout-form__submit-button checkout-form__submit-button--ready"
  }, [_c('button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.isProcessing),
      expression: "!isProcessing"
    }],
    attrs: {
      "disabled": _vm.isProcessing
    }
  }, [_vm._v("Complete Your Order")]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isProcessing),
      expression: "isProcessing"
    }]
  }, [_c('img', {
    attrs: {
      "src": _vm.loadingIndicatorSrc,
      "width": "16",
      "height": "16",
      "alt": ""
    }
  }), _vm._v("\n              Processing...\n            ")])])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "checkout-form__collection-method-message"
  }, [_c('p', [_vm._v("This order is for...")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "checkout-form__input-label"
  }, [_c('label', {
    attrs: {
      "for": "flyboy_deliver_contact"
    }
  }, [_vm._v("Delivery Contact *")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "checkout-form__input-label"
  }, [_c('label', {
    attrs: {
      "for": "flyboy_deliver_phone"
    }
  }, [_vm._v("Delivery Contact Phone *")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "checkout-form__input-label"
  }, [_c('label', {
    attrs: {
      "for": "flyboy_deliver_to"
    }
  }, [_vm._v("Deliver To Location/Address *")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "checkout-form__input-label"
  }, [_c('label', {
    attrs: {
      "for": "flyboy_deliver_message"
    }
  }, [_vm._v("Message To Include With Delivery")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "checkout-form__input-label"
  }, [_c('label', {
    attrs: {
      "for": "flyboy_deliver_instructions"
    }
  }, [_vm._v("Any Special Delivery Instructions?")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "checkout-form__input-field-tips-input-label"
  }, [_c('label', {
    attrs: {
      "for": "tipAmount"
    }
  }, [_vm._v("Amount")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "checkout-form__input-field-tips-image"
  }, [_c('img', {
    attrs: {
      "src": "/images/tips.jpg",
      "alt": "FYI: tips are split between our overnight bakers as a bonus for their skilled hard work"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "checkout-form__input-label"
  }, [_c('label', {
    attrs: {
      "for": "customer_comments"
    }
  }, [_vm._v("Any comments or additional information regarding your Express Order?")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "checkout-form__input-label"
  }, [_c('label', {
    attrs: {
      "for": "customer_first_name"
    }
  }, [_vm._v("First Name *")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "checkout-form__input-label"
  }, [_c('label', {
    attrs: {
      "for": "customer_last_name"
    }
  }, [_vm._v("Last Name *")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "checkout-form__input-label"
  }, [_c('label', {
    attrs: {
      "for": "customer_email"
    }
  }, [_vm._v("Email Address *")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "checkout-form__input-label"
  }, [_c('label', {
    attrs: {
      "for": "customer_phone"
    }
  }, [_vm._v("Phone # *")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "checkout-form__input-label"
  }, [_c('label', {
    attrs: {
      "for": "customer_zip"
    }
  }, [_vm._v("Zip *")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "checkout-form__input-label"
  }, [_c('label', {
    attrs: {
      "for": "customer_optin"
    }
  }, [_vm._v("Sign up to receive sale notifications & occasional marketing emails about new specials (no more than 2 emails per week).")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "checkout-form__input-group"
  }, [_c('div', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "id": "stripe_payment"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "checkout-form__input-label"
  }, [_c('label', {
    attrs: {
      "for": "password"
    }
  }, [_vm._v("Enter a password")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "checkout-form__input-label"
  }, [_c('label', {
    attrs: {
      "for": "password_confirm"
    }
  }, [_vm._v("Re-Enter password")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-88f195b2"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = 458
// module chunks = 0